import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import perksNearMe from "@irati/ui/images/perks-near-me.svg";
import { connect } from "@irati/store/connect";
import { RouterLink } from "@irati/ui/src/Link";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
import { Body } from "@irati/ui/src/Typography";
import Hr from "@irati/ui/src/Layout/Hr";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { ButtonContainer, IconWrapper, Image, PerksNearMeHeader } from "../styled/PerksNearMeResults";
var PerksNearMeResults = function (_a, _b) {
    var searchTerm = _a.searchTerm, isMobile = _a.isMobile;
    var apps = _b.apps;
    var routerLinkUrl = "/perks/location?q=" + searchTerm;
    var perksNearMeTitle = (React.createElement(PerksNearMeHeader, null,
        React.createElement(FormattedMessage, { id: "perks.components.perksNearMeResults.heading" })));
    var perksNearMeDesc = (React.createElement(Body, { margin: [1, 0.5], overflow: "hidden" },
        React.createElement(FormattedMessage, { id: "perks.components.perksNearMeResults.para" })));
    return (React.createElement(React.Fragment, null,
        isMobile ? (React.createElement(Hr, null)) : (React.createElement(React.Fragment, null,
            perksNearMeTitle,
            React.createElement(Hr, { margin: [2, 0] }))),
        React.createElement(Flex, { marginTop: 2 },
            React.createElement(Image, { src: perksNearMe }),
            isMobile ? (React.createElement("div", null,
                perksNearMeTitle,
                perksNearMeDesc)) : (perksNearMeDesc)),
        React.createElement(ButtonContainer, null,
            React.createElement(RouterLink, { to: routerLinkUrl, app: apps.SEARCH },
                React.createElement(Button, { primary: true, full: true, marginTop: 1 },
                    React.createElement(IconWrapper, null,
                        React.createElement(Icon, { icon: IconTypes.location })),
                    React.createElement(FormattedMessage, { id: "perks.components.perksNearMeResults.buttonText", values: {
                            searchTerm: (React.createElement(React.Fragment, null, "\u201C" + searchTerm + "\u201D",
                                React.createElement("br", null)))
                        } }))))));
};
PerksNearMeResults.contextTypes = {
    apps: PropTypes.object.isRequired
};
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({ isMobile: mq.lessThan.md });
};
export default injectIntl(connect(mapStateToProps)(PerksNearMeResults));
